import { Container, Section } from '../layout';
import { Button, Icon } from '../ui';
import { firmData } from '../../data/firmData';

export const HeroSection = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Section id="hero" padding="xl" className="pt-20 bg-gradient-to-br from-background-white to-background-light">
      <Container>
        {/* Two-column layout: Content on left, Image on right */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center min-h-[600px] lg:min-h-[700px]">
          
          {/* Content Column */}
          <div className="order-2 lg:order-1 text-center lg:text-left">
            {/* Main Heading */}
            <div className="mb-8 animate-fade-in">
              <h1 className="heading-xl text-primary-navy mb-4 font-bold">
                {firmData.name}
              </h1>
              <p className="body-lg text-text-medium mb-2">
                {firmData.tagline}
              </p>
              <p className="body-base text-text-light">
                Established {firmData.foundingYear} • {firmData.statistics.yearsOfPractice} Years of Excellence
              </p>
            </div>

            {/* Key Highlights */}
            <div className="grid grid-cols-2 gap-4 sm:gap-6 mb-8 animate-slide-up">
              <div className="text-center lg:text-left">
                <div className="text-xl sm:text-2xl font-bold text-accent-gold mb-1">
                  {firmData.statistics.yearsOfPractice}+
                </div>
                <div className="text-xs sm:text-sm text-text-medium">Years of Practice</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-xl sm:text-2xl font-bold text-accent-gold mb-1">
                  {firmData.statistics.mattersHandled}+
                </div>
                <div className="text-xs sm:text-sm text-text-medium">Matters Handled</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-xl sm:text-2xl font-bold text-accent-gold mb-1">
                  {firmData.statistics.clientEngagements}+
                </div>
                <div className="text-xs sm:text-sm text-text-medium">Client Engagements</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-xl sm:text-2xl font-bold text-accent-gold mb-1">
                  {firmData.statistics.regionalOffices}
                </div>
                <div className="text-xs sm:text-sm text-text-medium">Regional Offices</div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start items-center mb-8 animate-fade-in-delay">
              <Button 
                variant="primary" 
                size="lg"
                onClick={scrollToContact}
                className="w-full sm:w-auto sm:min-w-[200px]"
              >
                Get Legal Consultation
              </Button>
              <Button 
                variant="secondary" 
                size="lg"
                onClick={scrollToAbout}
                className="w-full sm:w-auto sm:min-w-[200px]"
              >
                Learn About Our Firm
              </Button>
            </div>

            {/* Scroll Indicator - Only show on mobile/tablet */}
            <div className="lg:hidden animate-bounce">
              <button
                onClick={scrollToAbout}
                className="flex flex-col items-center text-text-light hover:text-primary-navy transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-primary-navy focus:ring-offset-2 rounded-md p-2"
                aria-label="Scroll to learn more about our firm"
              >
                <span className="text-sm mb-2">Learn More</span>
                <Icon name="chevronDown" size="md" aria-hidden={true} />
              </button>
            </div>
          </div>

          {/* Image Column */}
          <div className="order-1 lg:order-2 flex items-center justify-center">
            <div className="relative w-full max-w-md lg:max-w-lg animate-fade-in">
              {/* Hero image with proper aspect ratio */}
              <div className="relative aspect-[4/5] w-full rounded-lg overflow-hidden shadow-lg">
                <img
                  src="/images/scale-and-hammer.jpg"
                  alt="Professional Legal Services - Scale and Hammer"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              
              {/* Optional: Add a subtle shadow/glow effect */}
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-navy/5 to-accent-gold/5 rounded-xl blur-xl -z-10"></div>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};